import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { action } from "typesafe-actions";
import { IVendorPayment } from "./vendor-payments.types";
import { IQueryParams } from "../../common/common.types";
import { IStoreState } from "../../initialStoreState";
import { getSearchQuery } from "../../common/helpers";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import { isArray } from "lodash";
import { getUniqueId } from "../../../helpers";
import { IFileUpload } from "../../../components/FileUpload/FileUpload.type";
import {
  getFileNameFromUrl,
  uploadMultipleFile,
} from "../../../components/FileUpload/utils";
import { IDataTableV2DateState } from "../../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";

// / ********************** Fetch Expense Category List********************** //
export const FETCH_VENDOR_PAYMENT_LIST_PROGRESS =
  "FETCH_VENDOR_PAYMENT_LIST_PROGRESS";
export const FETCH_VENDOR_PAYMENT_LIST_SUCCESS =
  "FETCH_VENDOR_PAYMENT_LIST_SUCCESS";
export const FETCH_VENDOR_PAYMENT_LIST_FAILED =
  "FETCH_VENDOR_PAYMENT_LIST_FAILED";

export const fetchVendorPaymentsListProgress = () =>
  action(FETCH_VENDOR_PAYMENT_LIST_PROGRESS);
export const fetchVendorPaymentsListSuccess = (
  data: IVendorPayment[],
  totalRecords: number,
) => action(FETCH_VENDOR_PAYMENT_LIST_SUCCESS, { data, totalRecords });
export const fetchVendorPaymentsListFailed = () =>
  action(FETCH_VENDOR_PAYMENT_LIST_FAILED);

export const fetchVendorPaymentsListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    type: "EXPENCE" | "ADVANCE" | "VENDOR_PAYMENT",
    billing_company_uuid: string,
    searchByProject?: string,
    searchByCategory?: string,
    searchByExpenseFor?: string,
    searchByExpenseType?: string,
    expenseDate?: string,
    reportUuid?: string,
    unreported?: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      let url = `&billing_company_uuid=${billing_company_uuid}&expense_type=${type}`;

      if (reportUuid) {
        url += `&report_uuid=${reportUuid}`;
      }
      if (unreported) {
        url += `&unreported=${unreported}`;
      }
      if (
        searchValue.length > 0 ||
        searchByProject ||
        expenseDate ||
        searchByCategory ||
        searchByExpenseFor ||
        searchByExpenseType
      ) {
        const advanceFilter = [...searchValue];
        if (searchByProject) {
          advanceFilter.push({
            column: ["project_name"],
            value: searchByProject,
            logicalOperator: "AND",
            operator: "CONTAINS",
          });
        }
        if (expenseDate) {
          advanceFilter.push({
            column: ["expense_date"],
            value: expenseDate,
            logicalOperator: "AND",
            operator: "EQUAL",
          });
        }
        if (searchByCategory) {
          advanceFilter.push({
            column: ["expense_category_name"],
            value: searchByCategory,
            logicalOperator: "AND",
            operator: "CONTAINS",
          });
        }
        if (searchByExpenseFor) {
          advanceFilter.push({
            column: ["user_name"],
            value: searchByExpenseFor,
            logicalOperator: "AND",
            operator: "CONTAINS",
          });
        }
        if (searchByExpenseType) {
          advanceFilter.push({
            column: ["expense_type"],
            value: searchByExpenseType,
            logicalOperator: "AND",
            operator: "CONTAINS",
          });
        }
        url += `&advanceFilter=${JSON.stringify(advanceFilter)}`;
      }

      if (status !== "-1") {
        url += `&status=${status}`;
      }

      const finalUrl =
        `/vendor/get-vendor-expense?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}` +
        url;

      dispatch(fetchVendorPaymentsListProgress());
      const res = await api.get(finalUrl);
      const data: IVendorPayment[] = res.data.data;
      const totalRecords = res.data.totalRecords;
      dispatch(fetchVendorPaymentsListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchVendorPaymentsListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

// export const fetchVendorPaymentsListAsync =
//   (
//     queryParams: IQueryParams,
//   ): ThunkAction<void, IStoreState, {}, AnyAction> =>
//   async (dispatch, getState) => {
//     try {
//       const searchQuery = getSearchQuery(queryParams);
//       dispatch(fetchVendorPaymentsListProgress());
//       let finalUrl = `/vendor/get-vendor-expense${searchQuery}`;
//       const res = await api.get(finalUrl);
//       const data: IVendorPayment[] = res.data.data;
//       const totalRecords = res.data.totalRecords;
//       dispatch(fetchVendorPaymentsListSuccess(data, totalRecords));
//     } catch (err: any) {
//       dispatch(fetchVendorPaymentsListFailed());
//       dispatch(
//         showMessage({
//           type: "error",
//           message: err.response.data.message,
//           displayAs: "snackbar",
//         }),
//       );
//     }
//   };

// ********************** Fetch Single Expense ********************** //
export const FETCH_SINGLE_VENDOR_PAYMENT_PROGRESS =
  "FETCH_SINGLE_VENDOR_PAYMENT_PROGRESS";
export const FETCH_SINGLE_VENDOR_PAYMENT_SUCCESS =
  "FETCH_SINGLE_VENDOR_PAYMENT_SUCCESS";
export const FETCH_SINGLE_VENDOR_PAYMENT_FAILED =
  "FETCH_SINGLE_VENDOR_PAYMENT_FAILED";

export const fetchSingleVendorPaymentProgress = () =>
  action(FETCH_SINGLE_VENDOR_PAYMENT_PROGRESS);
export const fetchSingleVendorPaymentSuccess = (data: IVendorPayment) =>
  action(FETCH_SINGLE_VENDOR_PAYMENT_SUCCESS, { data });
export const fetchSingleVendorPaymentFailed = (errorMessage: string) =>
  action(FETCH_SINGLE_VENDOR_PAYMENT_FAILED, { errorMessage });

export const fetchSingleVendorPaymentAsync =
  (
    uuid: string,
    billing_company_uuid: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchSingleVendorPaymentProgress());
      let url = `/vendor/get-vendor-expense?vendor_expense_uuid=${uuid}&billing_company_uuid=${billing_company_uuid}`;

      const res = await api.get(url);
      const data = res.data.data;

      if (data.length > 0) {
        let expenseData = data[0];
        expenseData.receipt = isArray(expenseData.receipt)
          ? expenseData.receipt
              .filter((item: any) => typeof item === "string")
              .map((file: string) => {
                return {
                  key: getUniqueId(),
                  type: "SERVER",
                  file: null,
                  name: getFileNameFromUrl(file || ""),
                  path: file,
                } as IFileUpload;
              })
          : [];
        dispatch(fetchSingleVendorPaymentSuccess(expenseData));
      } else {
        dispatch(
          fetchSingleVendorPaymentFailed("Oops! We couldn't find any records."),
        );
      }
    } catch (err: any) {
      dispatch(fetchSingleVendorPaymentFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

// ********************** Upsert Expense ********************** //
export const upsertSingleVendorPaymentAsync =
  (
    data: IVendorPayment,
    onCallback: (isSuccess: boolean, customer?: IVendorPayment) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const {
        create_ts,
        insert_ts,
        rowId,
        report_name,
        report_uuid,
        amount,
        requested_by_uuid,
        is_user_approver,
        approval_uuid,
        billing_company_branch_address_state,
        dynamic_approval_uuid,

        ...payload
      } = data;
      const asPayload = {
        title: data.expense_date,
      };
      // Corrected logic for mapping receipts
      const fileToUpload = isArray(payload.receipt)
        ? payload.receipt.filter((item) => item.type === "LOCAL")
        : [];
      if (fileToUpload.length > 0) {
        const { paths } = await uploadMultipleFile(
          fileToUpload,
          "REPORT",
          asPayload,
        );
        payload.receipt = payload.receipt
          .filter((item) => item.type === "SERVER" && item.path)
          .map((item) => item.path!)
          .concat(paths as string[]) as any;
      } else {
        payload.receipt = payload.receipt
          .filter((item) => item.type === "SERVER" && item.path)
          .map((item) => item.path!) as any;
      }

      dispatch(saveLoaderProgress());
      const res = await api.post("/vendor/upsert-vendor-expense", {
        ...payload,
      });

      const result = res.data.data[0];

      let message = "Expense created successfully!";
      onCallback(true, result);
      dispatch(
        showMessage({
          type: "success",
          displayAs: "snackbar",
          message: message,
        }),
      );
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

// ********************** getUserAdvanceExpenseAmountAsync ********************** //
export const getUserAdvanceExpenseAmountAsync =
  (
    uuid: string,
    onCallback: (isSuccess: boolean, advance: string) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const response = await api.get(
        `/expense/get-advance-amount?user_uuid=${uuid}`,
      );
      const result = response.data.data[0].advance_amount || 0;
      onCallback(true, result);
    } catch (err: any) {
      onCallback(false, "0");
      dispatch(
        showMessage({
          type: "error",
          message: err.response?.data?.message || "No advance amount available",
          displayAs: "snackbar",
        }),
      );
    }
  };

// ********************** Clear State********************** //
export const CLEAR_VENDOR_PAYMENT_LIST_STATE =
  "CLEAR_VENDOR_PAYMENT_LIST_STATE";
export const CLEAR_SINGLE_VENDOR_PAYMENT_STATE =
  "CLEAR_SINGLE_VENDOR_PAYMENT_STATE";
export const clearSingleVendorPaymentStateSync = () =>
  action(CLEAR_SINGLE_VENDOR_PAYMENT_STATE);
export const clearVendorPaymentListStateSync = () =>
  action(CLEAR_VENDOR_PAYMENT_LIST_STATE);
